import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModalCalculateComponent } from 'src/app/modules/report-management/modal-calculate/modal-calculate.component';

@Component({
  selector: 'lifedi-report-top-rank-template',
  templateUrl: './report-top-rank-template.component.html',
  styleUrls: ['./report-top-rank-template.component.scss']
})
export class ReportTopRankTemplateComponent implements OnInit {
  @Input() reportForm: FormGroup;
  @Input() reportType: string;
  @Input() reportID: string;
  @Input() measureID: string;
  @Input() isEdit: boolean;
  @Input() isPaid: boolean;
  color: any;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // console.log(this.reportForm);
    // console.log(this.reportForm.value);

    if (!this.isEdit || this.reportForm.value.PSY_BLOCKS.length === 0) { this.addGroup(); }
  }

  addGroup() {
    (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
      PSY_NAME: ['', Validators.required],
      COLOR_CODE: ['', Validators.required],
      DETAIL_PSY: ['', Validators.required],
      CAL: ['', Validators.required],
    }))
  }

  removeGroup(index) {
    (<FormArray>this.reportForm.get("PSY_BLOCKS")).removeAt(index);
  }

  openCalculateModal(form, i, isEdit) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      reportId: this.reportID,
      measureId: this.measureID,
      isEdit: isEdit,
      title: 'คำนวณ',
      calData: this.reportForm.value.PSY_BLOCKS[i].CAL,
      typeReport: this.reportType,
      actionBtnText: 'บันทึก',
    }

    const modal = this.matDialog.open(ModalCalculateComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          ((form as FormArray).at(i) as FormGroup).get('CAL').patchValue(res.data);
          // console.log(this.reportForm);
        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message)
        return of(null);
      }),
    ).subscribe();

  }

}
